import React, { useContext, useEffect, useState } from "react";
import "./Ride_In_Comfort.css";
import { Label } from "@progress/kendo-react-labels";
import Luxury_Cab_Modal from "../../luxury-cab-modal/Luxury_Cab_Modal";
import { getCabCategory } from "../../../utils/apis/Home/Homeapi";
import { Context } from "../../../utils/context";

const Ride_In_Comfort = () => {

  const {
    IMG_URL,
    Select2Data,
    getData,
    setSource,
    Source,
    Destination,
    setDestination,
    setDate,
    date,
    setTime,
    Time,
    seatCapacityId,
    setSeatCapacityId,
  } = useContext(Context);
  const [show, setShow] = useState(false);
  const vehicleData = [
    {
      title: "Luxury",
      image: "/assets/images/home/Ride_In_Comfort/luxury.png",
    },
    {
      title: "Premium",
      image: "/assets/images/home/Ride_In_Comfort/premium.png",
    },
    {
      title: "Comfort",
      image: "/assets/images/home/Ride_In_Comfort/comfort.png",
    },
    {
      title: "Economy",
      image: "/assets/images/home/Ride_In_Comfort/economy.png",
    },
    {
      title: "Bikes",
      image: "/assets/images/home/Ride_In_Comfort/bike.png",
    },
  ];

  const [dataCabCategory, setDataCabCategory] = useState();
  const getAllDataCabCategory = async () => {
    const res = await getCabCategory();

    if (res?.success) {
      setDataCabCategory(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }

  useEffect(() => {
    getAllDataCabCategory();

  }, []);

  return (
    <section className="Ride_In_Comfort">
      <div className="container">
        <div className="Ride_In_Comfort_header_div">
          <h5 className="ride">Ride in Comfort</h5>
          <p className="ride_text">
            Our diverse fleet features a wide range of models, thoughtfully
            organized into four distinct service tiers
          </p>
        </div>

        <div className="vehicle_category_section">
          <div className="row justify-content-center mt-5">
            {dataCabCategory?.map((vehicle, index) => (
              <div className="col-lg-2 col-md-3 col-sm-4 col-6 mb-5">
                <div className="vehicle_card" onClick={() => setShow(vehicle)}>
                  {/* Top Title */}
                  <div className="vehicle_card_header">{vehicle.name}</div>

                  {/* Blue Body */}
                  <div className="vehicle_card_body">
                    <img
                      src={IMG_URL + vehicle.image}
                      alt={vehicle.name}
                      className="vehicle_image"
                    />
                  </div>

                  <div className="view_all_btn">
                    <button className="view_all">View More</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Luxury_Cab_Modal
        show={show}
        handleClose={() => setShow(false)}
      />
    </section>
  );
};

export default Ride_In_Comfort;
